
import Login from '../../components/auth/Login'

function LoginPage() {
  return (
        <Login/>
  )
}

export default LoginPage